export const SET_ENEMY_PLAYER = 'SET_ENEMY_PLAYER'
export const UNSET_ENEMY_PLAYER = 'UNSET_ENEMY_PLAYER'
export const PUNCH_FROM_PLAYER_TO_ENEMY_PLAYER = 'PUNCH_FROM_PLAYER_TO_ENEMY_PLAYER'
export const SET_CHAT = 'SET_CHAT'
export const UNSET_CHAT = 'UNSET_CHAT'